import styled from 'styled-components/macro';

export const SidePanelContentWrapper = styled.div`
  display: grid;
  align-content: start;
  gap: 1rem;
  padding-right: 1rem;
`;
